import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { customHeight, usePrevious, usePreviousReference } from "../../utils";
import { Skeleton } from "../../components/Skeleton";
import "../liverate/liverate.css";
import { SocketContext } from "../../App";
import "../../components/Skeleton/Skelton.css";
import pako from "pako";
import HighImg from "../../images/up-arrow.png";
import LowImg from "../../images/down-arrow.png";

export default function Liverate() {
  const socketContext = useContext(SocketContext);
  const [maindata, setMaindata] = useState(null);
  const [referenceProductData, setReferenceProductData] = useState(null);

  const clientdetails = useSelector((state) => state.clientDetails);
  const clientData = !!clientdetails?.length ? clientdetails : [];
  // const maindata = useSelector((state) => state.mainProduct);
  const previousMainProduct = usePrevious(!!maindata ? maindata : []);
  const referenceData = useSelector((state) => state.referanceDetails);
  // const referenceProductData = useSelector((state) => state.referanceProduct);
  const previousReferenceProductData = usePreviousReference(
    !!referenceProductData ? referenceProductData : []
  );
  const [adBannerDisplay, setAdBannerDisplay] = useState("block");
  let displayFutureRef = useRef({});
  let displayNextRef = useRef({});
  let displaySpot = useRef({});
  let heightObj = {
    mainProduct: "78.5px",
    referenceProductData: "156.39px",
    mainProductTitle: "48px",
  };

  let isLoading = Skeleton({
    dependency: {
      maindata: maindata,
      referenceProductData: referenceProductData,
    },
  });

  const backgroundColorClass = (current, previous) => {
    if (current > previous) {
      return "h";
    } else if (current < previous) {
      return "l";
    } else {
      return "e";
    }
  };

  let Ratedisplay = "none";
  let available = "none ";
  let isbuy;
  let issell;
  let ishigh;
  let islow;

  for (let data of clientData) {
    if (!!maindata && data?.isRate === true && maindata?.length > 0) {
      Ratedisplay = "block";
      available = "none";
      if (data?.isBuy === true) {
        isbuy = "";
      } else {
        isbuy = "none";
      }
      if (data?.isSell === true) {
        issell = "";
      } else {
        issell = "none";
      }
      if (data?.isHigh === true) {
        ishigh = "";
      } else {
        ishigh = "none";
      }
      if (data?.isLow === true) {
        islow = "";
      } else {
        islow = "none";
      }
    } else if ((!!maindata && maindata?.length < 1) || !data?.isRate) {
      Ratedisplay = "none";
      available = "block";
    }
    if (data?.isBuy === false && data?.isHigh === false && data.isLow === false && data.isSell === false) {
      available = "block"
      Ratedisplay = "none";
    }

  }
  // Main product
  const renderMainProduct = useMemo(() => {
    if (!previousMainProduct) return null;

    if (!!maindata) {
      return maindata?.map((item, index) => {
        if (item?.src === "gold" || item?.src === "silver") {
          const prevItem = previousMainProduct?.find((prev) => Number(item.id) === Number(prev.id));
          const bgAsk = backgroundColorClass(item?.ask, prevItem?.ask);
          const bgBid = backgroundColorClass(item?.bid, prevItem?.bid);
          return (
            <>
              <div className="content-cover" key={index}>
                <table>
                  <tbody>
                    <tr className="ligh-white">
                      <td className="p-h p0">
                        <div className="main-product-cover">
                          <h3>{item.name}</h3>
                        </div>
                      </td>
                      <td className="p-h ph product-rate" style={{ display: isbuy === "none" && islow === "none" && "none" }}>
                        <div className="mn-rate-cover">
                          <span className={`bgm ${bgBid}`} style={{ display: isbuy }}>
                            {item.bid}
                          </span>
                          <span className="bgs hl" style={{ display: islow }}>
                            L - {item.low}
                          </span>
                        </div>
                      </td>
                      <td className="p-h ph product-rate" style={{ display: issell === "none" && ishigh === "none" && "none" }}>
                        <div className="mn-rate-cover">
                          <span className={`bgm ${bgAsk}`} style={{ display: issell }}>
                            {item.ask}
                          </span>
                          <span className="bgs hl" style={{ display: ishigh }}>
                            H - {item.high}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          );
        }
      });
    }
  }, [maindata]);

  //Future product
  const renderFutureProduct = useMemo(() => {
    if (!previousReferenceProductData) return null;

    if (!!referenceProductData) {
      return referenceProductData?.map((item, index) => {
        // const referenceItem = referenceData[index];
        if (item?.symbol === "gold" || item?.symbol === "silver") {
          const referenceItem = !!referenceData
            ? referenceData?.find((val) => val?.source === item?.symbol)
            : null;
          const bgAsk = backgroundColorClass(
            item?.Ask,
            previousReferenceProductData[index]?.Ask
          );
          const bgBid = backgroundColorClass(
            item?.Bid,
            previousReferenceProductData[index]?.Bid
          );

          let Symbol_Name;
          let diff;
          if (
            referenceItem?.source === "gold" ||
            referenceItem?.source === "silver"
          ) {
            Symbol_Name = referenceItem?.name;
          }

          if (!!!referenceItem) {
            displayFutureRef.current[item?.symbol] = false;
          } else {
            displayFutureRef.current[item?.symbol] = true;
          }
          if (item.Difference >= 0) {
            diff = "green";
          } else if (item.Difference <= 0) {
            diff = "red";
          } else {
            diff = "black";
          }
          return (
            <div className="content-cover" key={Symbol_Name} style={{ display: !!referenceItem ? "block" : "none" }}>
              <table>
                <tbody>
                  <tr className="ligh-white">
                    <td className="p-h p0">
                      <div className="main-product-cover">
                        <h3>{Symbol_Name}</h3>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgBid}`}>{item?.Bid}</span>
                        <span className="bgs hl" style={{}}>
                          L - {item?.Low}
                        </span>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgAsk}`}>{item?.Ask}</span>
                        <span className="bgs hl" style={{}}>
                          H - {item?.High}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
      });
    }
  }, [referenceProductData]);

  // Next Product
  const renderNextProduct = useMemo(() => {
    if (!previousReferenceProductData) return null;

    if (!!referenceProductData) {
      return referenceProductData?.map((item, index) => {
        // const referenceItem =  referenceData[index];

        if (item?.symbol === "goldnext" || item?.symbol === "silvernext" || item?.symbol === "gldmini" || item?.symbol === "slmini") {

          const referenceItem = !!referenceData
            ? referenceData?.find((val) => val?.source === item?.symbol)
            : null;
          const bgAsk = backgroundColorClass(
            item?.Ask,
            previousReferenceProductData[index]?.Ask
          );
          const bgBid = backgroundColorClass(
            item?.Bid,
            previousReferenceProductData[index]?.Bid
          );

          let Symbol_Name;

          if (
            referenceItem?.source === "goldnext" ||
            referenceItem?.source === "silvernext" ||
            referenceItem?.source === "gldmini" ||
            referenceItem?.source === "slmini"
          ) {
            Symbol_Name = referenceItem?.name;
          }

          if (!!!referenceItem) {
            displayNextRef.current[item?.symbol] = false;
          } else {
            displayNextRef.current[item?.symbol] = true;
          }
          let diff;
          if (item.Difference >= 0) {
            diff = "green";
          } else if (item.Difference <= 0) {
            diff = "red";
          } else {
            diff = "black";
          }
          return (
            <div className="content-cover" key={Symbol_Name} style={{ display: !!referenceItem ? "block" : "none" }}>
              <table>
                <tbody>
                  <tr className="ligh-white">
                    <td className="p-h p0">
                      <div className="main-product-cover">
                        <h3>{Symbol_Name}</h3>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgBid}`}>{item?.Bid}</span>
                        <span className="bgs hl" style={{}}>
                          L - {item?.Low}
                        </span>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgAsk}`}>{item?.Ask}</span>
                        <span className="bgs hl" style={{}}>
                          H - {item?.High}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
      });
    }
  }, [referenceProductData]);

  //Spot product
  const renderSpotProduct = useMemo(() => {
    if (!previousReferenceProductData) return null;

    if (!!referenceProductData) {
      return referenceProductData?.map((item, index) => {
        // const referenceItem = !!referenceData ? referenceData[index] : []

        if (
          item?.symbol === "XAUUSD" ||
          item?.symbol === "XAGUSD" ||
          item?.symbol === "INRSpot"
        ) {
          const referenceItem = !!referenceData
            ? referenceData?.find((val) => val?.source === item?.symbol)
            : null;
          const bgAsk = backgroundColorClass(
            item?.Ask,
            previousReferenceProductData[index]?.Ask
          );
          const bgBid = backgroundColorClass(
            item?.Bid,
            previousReferenceProductData[index]?.Bid
          );

          let Symbol_Name;

          if (
            referenceItem?.source === "XAUUSD" ||
            referenceItem?.source === "XAGUSD" ||
            referenceItem?.source === "INRSpot"
          ) {
            Symbol_Name = referenceItem?.name;
          }

          if (!!!referenceItem) {
            displaySpot.current[item?.symbol] = false;
          } else {
            displaySpot.current[item?.symbol] = true;
          }

          return (
            <div className="content-cover" key={Symbol_Name} style={{ display: !!referenceItem ? "block" : "none" }}>
              <table>
                <tbody>
                  <tr className="ligh-white">
                    <td className="p-h p0">
                      <div className="main-product-cover">
                        <h3>{Symbol_Name}</h3>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgBid}`}>{item?.Bid}</span>
                        <span className="bgs hl" style={{}}>
                          L - {item?.Low}
                        </span>
                      </div>
                    </td>
                    <td className="p-h ph product-rate">
                      <div className="mn-rate-cover">
                        <span className={`bgm ${bgAsk}`}>{item?.Ask}</span>
                        <span className="bgs hl" style={{}}>
                          H - {item?.High}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
      });
    }
  }, [referenceProductData]);

  const handleAdBanner = () => {
    setAdBannerDisplay("none");
  };

  useEffect(() => {
    socketContext.on("mainProducts", function (data) {
      try {
        if (!!data) {
          var strLiveRates = pako.inflate(data, { to: "string" });
          var mainproducts = JSON.parse(strLiveRates);
          if (!!mainproducts) {
            setMaindata(mainproducts);
          } else {
            setMaindata([]);
          }
        } else {
          setMaindata([]);
        }
      } catch (error) {
        console.log(error);
      }
    });

    socketContext.on("referanceProducts", function (data) {
      try {
        if (!!data) {
          var referance = pako.inflate(data, { to: "string" });
          var referanceproducts = JSON.parse(referance);
          if (referanceproducts.length !== 0) {
            setReferenceProductData(referanceproducts);
          } else {
            setReferenceProductData([]);
          }
        } else {
          setReferenceProductData([]);
        }
      } catch (error) {
        console.log("referanceProducts error", error);
      }
    });

    return () => {
      socketContext.off("mainProducts");
      socketContext.off("referanceProducts");
    };
  }, []);

  return (
    <>
      <section className="middle-section">
        <div className="marquee-cover">
          <div className="container">
            {!!clientData?.[0]?.bannerWeb && (
              <div className="add-banner" style={{ display: adBannerDisplay }}>
                <div className="cross">
                  <span className="close btn" onClick={handleAdBanner}>
                    x
                  </span>
                </div>
                <img
                  id="advetiseImg"
                  src={clientData?.[0]?.bannerWeb}
                  alt="AD banner"
                />
              </div>
            )}
          </div>
        </div>

        {/* =================> Spot RAte */}
        {/* <div className="gold-spot-cover">
          <div className="container">
            <div className="gold-spot">
              <div className="row" id="divSpot">
                {[1, 2, 3].map((item) => {
                  return (
                    <div className="col-md-4">
                      <div
                        className={`${
                          !!!isLoading?.referenceProductData
                            ? "skeleton"
                            : "spot-content"
                        }`}
                        style={{
                          height: !!!isLoading?.referenceProductData
                            ? customHeight(heightObj?.referenceProductData)
                            : "",
                          marginTop:
                            !!!isLoading?.referenceProductData && "10px",
                        }}
                      ></div>
                    </div>
                  );
                })}

                {!!isLoading?.referenceProductData && renderSpotProduct}
              </div>
            </div>
          </div>
        </div> */}


        {/* <div className="gold-spot-cover desinround">
      <div className="container">
      <div className="row" id="divSpot">
                {[1, 2].map((item) => {
                  return (
                    <div className="col-md-6">
                      <div
                        className={`${
                          !!!isLoading?.referenceProductData
                            ? "skeleton"
                            : "spot-content"
                        }`}
                        style={{
                          height: !!!isLoading?.referenceProductData
                            ? customHeight(heightObj?.referenceProductData)
                            : "",
                          marginTop:
                            !!!isLoading?.referenceProductData && "10px",
                        }}
                      ></div>
                    </div>
                  );
                })}
                {!!isLoading?.referenceProductData && renderFutureProduct}
              </div>
              <div className="row" id="divSpot">
                {[1, 2].map((item) => {
                  return (
                    <div className="col-md-6">
                      <div
                        className={`${
                          !!!isLoading?.referenceProductData
                            ? "skeleton"
                            : "spot-content"
                        }`}
                        style={{
                          height: !!!isLoading?.referenceProductData
                            ? customHeight(heightObj?.referenceProductData)
                            : "",
                          marginTop:
                            !!!isLoading?.referenceProductData && "10px",
                        }}
                      ></div>
                    </div>
                  );
                })}
                {!!isLoading?.referenceProductData && renderNextProduct}
              </div>
      </div>
    </div> */}




        {/* =================>  Main Product */}
        <div className="liverate-cover">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-6 ">
                {/* =================>  Reference Product */}
                <div className="liverate-cover refrence">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 p-l-r p-0">
                        <div className="main-product">
                          {[...Array(7)].map((item, ind) => {
                            if (!isLoading.referenceProductData) {
                              return (
                                <div
                                  className={`${!!!isLoading?.referenceProductData
                                    ? "skeleton mainproduct-skeleton"
                                    : ""
                                    } `}
                                  style={{
                                    height: !!!isLoading?.referenceProductData
                                      ? ind === 0
                                        ? customHeight(heightObj?.mainProductTitle)
                                        : customHeight(heightObj?.mainProduct)
                                      : "",
                                  }}
                                ></div>
                              );
                            }
                          })}
                          {isLoading.referenceProductData && referenceData.length > 0 && <div id="referenceProductHeader" >
                            <table className="table">
                              <tbody>
                                <tr className="product-title-color">
                                  <td className="p-h p0">
                                    <span>PRODUCT</span>
                                  </td>
                                  <td className="p-h ph text-center">
                                    <span>BID</span>
                                  </td>
                                  <td className="p-h ph text-center">
                                    <span>ASK</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>}


                          <div className="divProduct" id="divSpot">
                            {!!isLoading?.referenceProductData && renderSpotProduct}
                          </div>
                          {/* <div className="divProduct" id="divFuture">
                            {!!isLoading?.referenceProductData && renderFutureProduct}
                          </div>
                          <div className="divProduct" id="divNext">
                            {!!isLoading?.referenceProductData && renderNextProduct}
                          </div> */}
                        </div>
                      </div>


                      <div className="col-md-12 p-l-r p-0">
                        <div className="main-product">
                          {[...Array(7)].map((item, ind) => {
                            if (!isLoading.referenceProductData) {
                              return (
                                <div
                                  className={`${!!!isLoading?.referenceProductData
                                    ? "skeleton mainproduct-skeleton"
                                    : ""
                                    } `}
                                  style={{
                                    height: !!!isLoading?.referenceProductData
                                      ? ind === 0
                                        ? customHeight(heightObj?.mainProductTitle)
                                        : customHeight(heightObj?.mainProduct)
                                      : "",
                                  }}
                                ></div>
                              );
                            }
                          })}
                          {isLoading.referenceProductData && referenceData.length > 0 && <div id="referenceProductHeader" >
                            <table className="table">
                              <tbody>
                                <tr className="product-title-color">
                                  <td className="p-h p0">
                                    <span>PRODUCT</span>
                                  </td>
                                  <td className="p-h ph text-center">
                                    <span>BID</span>
                                  </td>
                                  <td className="p-h ph text-center">
                                    <span>ASK</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>}
                          <div className="divProduct" id="divFuture">
                            {!!isLoading?.referenceProductData && renderFutureProduct}
                          </div>
                          <div className="divProduct" id="divNext">
                            {!!isLoading?.referenceProductData && renderNextProduct}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6  ps-lg-0 ps-3">
                <div className="main-product">
                  <h1 className="text-center whitecl" style={{ display: available, color: "#fff", marginBottom: "40px" }}>Live Rate currently not available.</h1>

                  <div id="divHeader" style={{ display: available === "block" ? "none" : !!!isLoading?.maindata ? "none" : "block" }}>
                    <table>
                      <tbody>
                        <tr className="product-title-color">
                          <td className="p-h p0">
                            <span>PRODUCT</span>
                          </td>
                          <td className="p-h ph text-center" style={{ display: isbuy === "none" && islow === "none" && "none" }}>
                            <span>BUY</span>
                          </td>
                          <td className="p-h ph text-center" style={{ display: issell === "none" && ishigh === "none" && "none" }}>
                            <span>SELL</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {[1, 2, 3].map((item, ind) => {
                    if (!isLoading?.maindata) {
                      return (
                        <div
                          className={`${!!!isLoading?.maindata
                            ? "skeleton mainproduct-skeleton"
                            : ""
                            } `}
                          style={{
                            height: !!!isLoading?.maindata
                              ? ind === 0
                                ? customHeight(heightObj?.mainProductTitle)
                                : customHeight(heightObj?.mainProduct)
                              : "",
                          }}
                        ></div>
                      );
                    }
                  })}

                  {!!isLoading?.maindata && (
                    <div className="divProduct" id="divProduct" style={{ display: Ratedisplay }}>
                      {renderMainProduct}
                    </div>
                  )}
                </div>
              </div>

            </div>

          </div>
        </div>

      </section>
    </>
  );
}
